import { render } from "./search-drawer-group.vue?vue&type=template&id=174ddc05"
import script from "./search-drawer-group.vue?vue&type=script&lang=js"
export * from "./search-drawer-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__